import { render, staticRenderFns } from "./AdminArticles.vue?vue&type=template&id=bcfa857e"
import script from "./AdminArticles.vue?vue&type=script&lang=js"
export * from "./AdminArticles.vue?vue&type=script&lang=js"
import style0 from "./AdminArticles.vue?vue&type=style&index=0&id=bcfa857e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports